import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem('theme');
      if (saved === null) return false;
      // Handle both JSON and plain string values
      if (saved === 'true' || saved === 'false') {
        return saved === 'true';
      }
      return JSON.parse(saved);
    } catch (error) {
      console.warn('Error parsing theme from localStorage:', error);
      return false;
    }
  });

  useEffect(() => {
    localStorage.setItem('theme', JSON.stringify(isDark));
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  const theme = {
    isDark,
    toggleTheme,
    colors: {
      primary: isDark ? '#00ff88' : '#007acc',
      secondary: isDark ? '#ff6b6b' : '#ff4757',
      background: isDark ? '#0a0a0a' : '#ffffff',
      surface: isDark ? '#1a1a1a' : '#f8f9fa',
      text: isDark ? '#ffffff' : '#2c3e50',
      textSecondary: isDark ? '#b0b0b0' : '#7f8c8d',
      accent: isDark ? '#ffd700' : '#f39c12',
      gradient: isDark 
        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        : 'linear-gradient(135deg, #74b9ff 0%, #0984e3 100%)'
    }
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};